<a *ngIf="canDisplayLink" (click)='click($event)' href="#">{{ file.fileName }}</a>
<label *ngIf="!canDisplayLink">{{ file.fileName }}</label>